
    <label><input #checkbox type="checkbox" [checked]="isChecked()" [disabled]="disabled" (change)="onCheckBoxChange(checkbox)">{{label}}</label>
  